import { Search } from "lucide-react";
import type { BiddingInfo } from "../../../types";
import { useMemo } from "react";

type Props = {
  foundItem: BiddingInfo | null;
  onBidCancel: () => void;
  totalCapacity: number;
};

export const BiddingItemNumberDetail = ({
  foundItem,
  onBidCancel,
  totalCapacity,
}: Props) => {
  // 生産者表示有無フラグ判定ロジック
  const canSeeFarmerName = useMemo(() => {
    if (!foundItem) return false;
    // 買手専用なので、Hiddenフラグの反転のみで判定
    return !foundItem.isFarmerHidden;
  }, [foundItem?.isFarmerHidden]);

  // --- データなし (検索前) ---
  if (!foundItem) {
    return (
      // <div className="shrink-0 h-full min-h-[140px] bg-white rounded-xl shadow-sm border-2 border-dashed border-slate-200 p-4 flex flex-col items-center justify-center text-slate-300 gap-2">
      //   <Search className="w-10 h-10 opacity-20" />
      <div className="shrink   h-full min-h-[60px]  bg-white rounded-xl shadow-sm border-2 border-dashed border-slate-200 p-2 flex flex-col items-center justify-center text-slate-300 gap-1">
        <Search className="w-6 h-6 opacity-20" />
        <span className="text-base font-bold opacity-50">出品データ検索</span>
        <span className="text-xs opacity-40">入札番号を入力してください</span>
      </div>
    );
  }

  // --- データあり ---
  return (
    <div className="w-full bg-white rounded-xl shadow-sm border border-slate-200 p-2 ">
      <div className="flex flex-col gap-0.5">
        {/* 荷印と入札額を横並びに配置 */}
        <div className="flex flex-row justify-between items-start border-b border-slate-100 pb-1 mb-1">
          {/* 荷印 */}
          <div className="flex flex-col items-start">
            {/* <div className="text-[15px] [@media(min-height:700px)]:text-[18px] [@media(min-height:741px)]:text-[20px] text-slate-800 mb-0.5 font-bold transition-all">
              荷印
            </div> */}
            <div className="text-lg [@media(min-height:700px)]:text-[22px] [@media(min-height:741px)]:text-2xl font-black text-slate-800 leading-none transition-all">
              {foundItem.brand || "-"}
            </div>
          </div>

          {/*  入札取消ボタン */}
          <div>
            {foundItem.bidPrice > 0 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onBidCancel();
                }}
                className="px-2 py-1 text-[10px] [@media(min-height:700px)]:px-4 [@media(min-height:700px)]:py-1.5 [@media(min-height:700px)]:text-xs [@media(min-height:800px)]:text-sm bg-white border-2 border-red-500 text-red-600 font-bold rounded-lg shadow-sm active:scale-95 hover:bg-red-50 transition-all"
              >
                入札取消
              </button>
            )}
          </div>
        </div>

        {/* 売手・生産者  */}
        <div className="pt-1">
          {/* <div className="text-[15px] text-slate-800 mb-0.5 font-bold"> */}
          {/* <div className="text-[15px] [@media(min-height:700px)]:text-[18px] [@media(min-height:741px)]:text-[20px] text-slate-800 mb-0.5 font-bold transition-all">
            売手 / 生産者
          </div> */}
          <div className="flex flex-col">
            <div className="text-[15px] [@media(min-height:700px)]:text-[18px] [@media(min-height:741px)]:text-[20px] font-bold text-slate-800 leading-tight transition-all">
              {foundItem.sellerName || "-"}
            </div>
            <div className="text-[15px] [@media(min-height:700px)]:text-[18px] [@media(min-height:741px)]:text-[20px] font-bold text-slate-800 leading-tight transition-all">
              {canSeeFarmerName ? foundItem.farmerName || "-" : "-"}
            </div>
          </div>

          {/* ラベル */}
          {/* 左右に配置するコンテナ */}
          <div className="flex flex-row justify-between items-end pt-1">
            {/* --- 左側：総量グループ --- */}
            <div className="flex flex-col items-start">
              {/* <div className="text-[15px] text-slate-800 mb-0.5 font-bold"> */}
              <div className="text-[13px] [@media(min-height:700px)]:text-[16px] [@media(min-height:741px)]:text-[18px] text-slate-500 font-bold transition-all">
                総量（kg）
              </div>
              {/* <div className="text-lg font-bold text-slate-800 leading-tight"> */}
              <div className="text-lg [@media(min-height:700px)]:text-[22px] [@media(min-height:741px)]:text-[24px] font-bold text-slate-800 leading-tight transition-all">
                {totalCapacity ? totalCapacity.toLocaleString() : "-"}
              </div>
            </div>

            {/* --- 右側：最低落札値グループ（items-endで右寄せ） --- */}
            <div className="flex flex-col items-end">
              {/* 右寄せ・赤文字・太字 */}
              {/* <div className="text-[15px] text-red-500 font-bold mb-0.5"> */}
              <div className="text-[13px] [@media(min-height:700px)]:text-[16px] [@media(min-height:741px)]:text-[18px] text-slate-500 font-bold transition-all">
                最低落札値（円）
              </div>
              {/* <div className="text-lg font-bold text-red-500 leading-tight"> */}
              <div className="text-lg [@media(min-height:700px)]:text-[22px] [@media(min-height:741px)]:text-[24px] font-bold text-slate-800 leading-tight transition-all">
                {foundItem.bidMinPrice
                  ? foundItem.bidMinPrice.toLocaleString()
                  : "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
